import React from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormCreateCheese = ({ handleCreateCheese }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    handleCreateCheese(data);
  };

  return (
    <div className="container">
      <div className="cheese-form-container mx-auto">
        <h3 className="text-center fw-bold products-title ">
          Crear Nuevo Queso
        </h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Nombre del queso</label>
            <input
              type="text"
              className={`form-control ${
                errors.cheese_description ? "is-invalid" : ""
              }`}
              placeholder="Ejemplo: Dambo, Cheddar, Mozzarella, etc."
              {...register("cheese_description", {
                required: "Este campo es obligatorio",
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.cheese_description?.message || ""}
            </div>
          </div>

          <button type="submit" className="btn products-btn  w-100">
            Crear Queso
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormCreateCheese;
